<template>
  <div id="aprication">
    <div class="header-div">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="header-div" style="text-align: right">
      <el-button v-if="$hasPerm('system:sysDept:add')" size="mini" @click="handleAdd()" style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="deptId"
      border
      size="medium"
      :tree-props="{children: 'children'}">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column prop="name" label="部门名称"
                       style="width: 25%"></el-table-column>
      <el-table-column prop="orderNum" label="排序"
                       style="width: 25%"></el-table-column>
      <el-table-column label="操作" v-if="$hasPerm('system:sysDept:edit,system:sysDept:add,system:sysDept:remove')">
        <template slot-scope="scope">
          <el-button v-if="$hasPerm('system:sysDept:edit')" size="mini" @click="handleEdit(scope.$index, scope.row)"><i class="el-icon-edit"></i></el-button>
          <el-button v-if="$hasPerm('system:sysDept:add')" style="margin-right: 5px;" size="mini" @click="handleAddNext(scope.$index, scope.row)">添加下级<i class="el-icon-plus"></i></el-button>
          <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.$index, scope.row)">
            <el-button size="mini" slot="reference" v-if="$hasPerm('system:sysDept:remove')" type="danger">删除<i class="el-icon-delete"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pagesize"
            :pager-count="9"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
    ></el-pagination> -->
    <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
  </div>
</template>
<script>
  import Edit from './edit'

  export default {
    name: 'DeptList',
    components: {
      Edit
    },
    data() {
      return {
        currentPage: 1, //初始页
        pagesize: 10, //    每页的数据
        total: 0,
        offset: 0,
        tableData: [],
        editVisible: false
      }
    },
    methods: {
      handleCurrentChange(cPage) {
        console.log(cPage);
        this.offset = (cPage - 1) * this.pagesize;
        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/system/sysDept/tree2'),
          method: 'post'
        }).then(r => {
          this.tableData = r.data.data;
        }).finally(r => {})
      },
      //时间格式化
      dateFormat: function (row, column) {
        let date = row[column.property];
        /*if(date == 1){return '是'};
        if(date == 0){return '否'};*/
        return date;
      },
      handleAdd() {
        this.editVisible = true;
        this.$nextTick(() => {
          this.$refs.edit.int('','',3);
        })
      },
      handleEdit(index, row) {
        let deptId = row.deptId;
        let name = row.name;
        this.editVisible = true;
        this.$nextTick(() => {
          this.$refs.edit.int(deptId,name,1);
        })
      },
      handleAddNext(index, row) {
        let deptId = row.deptId;
        let name = row.name;
        this.editVisible = true;
        this.$nextTick(() => {
          this.$refs.edit.int(deptId,name,2);
        })
      },
      handleDelete(index, row) {
        let deptId = row.deptId;

        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/system/sysDept/remove'),
          method: 'post',
          data: this.$httpTAG.adornData({
            'deptId': deptId
          })
        }).then(res => {
          if (res.data.code == 0) {
            this.$notify({
              title: '操作成功！',
              type: 'success',
              offset: 600
            });
            this.handleCurrentChange(1);
          } else {
            this.$message({ // 失败
              type: 'error',
              message: res.data.msg
            })
          }
        }).finally(r => {})
      }
    },
    created: function () {
      this.handleCurrentChange(this.currentPage);
    }
  }
</script>
<style scoped>
  .header-div {
    margin-bottom: 5px;
    float: left;
    width: 50%;
  }
  .el-button + .el-button{
    margin-left: 5px
  }
</style>
